import React from 'react';
import loading from '@assets/images/page-loading.gif';
import '@components/PageLoader/page-loader.scss';

const PageLoader = () => {
  return (
    <div className="loader">
      <div className="lds-dual-ring">
        <img src={loading} alt="" />
      </div>
    </div>
  );
}

export default PageLoader;
